import z from 'zod';
import { customEventBaseFields } from './base-fields';

const subjectType = ['content-unit'] as const;

const basicLearningFeedback = {
  id: z.string(),
  ...customEventBaseFields,
};

const learningFeedback = {
  ...basicLearningFeedback,
  to: z.array(z.string()),
  subject: z.object({
    type: z.enum(subjectType),
    id: z.string(),
    score: z.number().optional(),
    attemptNumber: z.number(),
  }),
};

const learningFeedbackMessageSent = {
  ...learningFeedback,
  messageId: z.string().optional(),
};

const learningFeedbackMessageDeleted = {
  ...basicLearningFeedback,
  messageId: z.string().optional(),
};

export default {
  created: z.object(learningFeedback),
  messageSent: z.object(learningFeedbackMessageSent),
  read: z.object(basicLearningFeedback),
  messageDeleted: z.object(learningFeedbackMessageDeleted),
};
